<template>
  <div class="wenti_box">
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          实体营业执照和公章携带不方便，总是容易弄丢，如何获取电子营业执照和电子公章？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          新设立企业申领营业执照的同时，可在市统一电子印章管理平台（地址：https://amr.sz.gov.cn/elecseal/seal-web/#/home）免费申领一套四枚电子印章（法定名称章、财务专用章、合同专用章、法定代表人名章）。存量企业可在市统一电子印章管理平台（地址：https://amr.sz.gov.cn/elecseal/seal-web/#/home）免费申领一套四枚电子印章（法定名称章、财务专用章、合同专用章、负责人章）。商事主体负责人（企业法定代表人、个体户经营者）通过微信、支付宝中的电子营业执照小程序或电子营业执照APP等方式，通过实名核身后自行下载“电子营业执照”。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">商事登记</div>
        <div class="time">2021-08-14 20:30:01</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          我从外地来深圳，发现粤康码红、黄码，如何解除？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          粤康码被赋于红、黄码，原因显示为“外省健康码红、黄码人员”，属于外省的健康码红、黄码导致，请您先联系赋码当地的12345热线处理外省的健康码异常状况，外省健康码异常状态解除后，粤康码会在数据同步后解除。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">疫情防控</div>
        <div class="time">2021-08-14 20:30:32</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          企业法人是境外人士，不能通过身份验证登录授权怎么办？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          法定代表人是境外人士，无法完成经办人授权的企业，需进行线下授权流程。
          第一步，需准备以下材料：
          （1）填写《“深i企”用户申请表》，并加盖企业公章；申请表请通过在线文档获取，网址：https://kdocs.cn/l/sr1QIodkRzJi
          （2）营业执照（或副本）复印件盖章；
          （3）法定代表人身份证明复印件盖章，如：身份证/回乡证/通行证/护照；
          （4）代理人身份证复印件盖章。
          （代理人、法定代表人身份证明请注明：本证明仅限办理XXX业务使用，如“深i企”经办人权限开通）
          第二步，线上申请：以上材料的电子版通过企业邮箱发送至“深i企”物品通运营专人邮箱：yangwenhong@smartcitysz.com
          ；
          第三步，线下提交材料：电子版材料收到物品通运营专人邮件回复确认后，请将纸质原版申请材料以快递形式邮寄至“深i企”，地址：福田区深业上城T1写字楼11楼深圳市智慧企业服务有限公司产品一部，联系电话：0755-27038037（暂不支持快递到付）。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">防疫通</div>
        <div class="time">2021-08-14 20:30:47</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          哪里可以获取劳动合同范本？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          为了增强企业和劳动者依法订立和履行劳动合同的意识，市人力资源保障局编制了《深圳市劳动合同参考文本》、《深圳市劳务派遣合同参考文本》和《深圳市简易劳动合同参考文本》，方便用人单位和劳动者参考使用。详情请登录深圳市人力资源与社会保障局官网获取，网址：http://hrss.sz.gov.cn/zmhd/cjwt/cjwt/ldgx/content/post_1994740.html
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">用工</div>
        <div class="time">2021-08-14 20:31:20</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.wenti_box {
  width: 1438px;
  background: #fff;
  .list-item {
    box-shadow: 0 1px 0 0 #eee;
    padding-bottom: 16px;
    margin: 16px 24px 17px 24px;
    box-sizing: border-box;
    padding: 12px 0 12px 0;
    .title {
      height: 33px;
      line-height: 33px;
      display: flex;
      .title-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADcklEQVRYCb1XzWsTQRR/bybtNjGxFltBsbYKolBbvCl4qSDkpNCbH2cvCv4HQqFnL1696EFQvIi3ioIXP1DQ4gcoVGxVtG0aKzYx2WZnnvM2TdxsJ+tuwQwk+z5/v7czuzP7EEKD3h/Lrbk0JAgHUEAaSMlQSDIVpSINFY1U6HZwHg8+Xg0CYEMhmhTwZnpEEQ03bP/jKhHnYDT/DnFSM75fAJN7M9NHUdD2/0EaxiSNxdTh/DMuQvhOc+edImc+n8tw+jKvuXLVOCudHtKRjwQ/cJ0mbvD5Dzs/7Q1Dp6/MLfxXrdPM63zMnUr8niOJcnF2olYrj5PSgwTgP8iIUEOUc06671a6d8+LWPdk9phUrEAOUp6zujJ71vPcI6TVrnAeEXQRqf2V8vJl45uKW0T9NQyjWfSfxQ8Xamu/J2zk4XC3snI6bGunx54B7blH/4KY/cssYMsw+y2AWRD+JzXsCzH+YhdgKLtB5iA9dhNS/ScMdPiIUOAtP4DK63NmuVq2+8gyQrcRESvkfPeei4Y8byHnPOn7OAal/BSB1OKKXYDjbLuNmb0tyTZFbNlHTs/2mzafzRa7gEzf0NPu3IEZG0jQ1pUbeZnu3f0qaIuSYxfAIKJnZyEKzI9x+n/8KyboT1QAabccTLbJcWKCeYkKENX52WCyTY4TE8xLVAAWrj0HqC4EAVrl6kI9ptUapSUqANyvVVm4cUWT8sKgbGMfx4R9UXqyAgwSLl3/UFz8/PFXqQxVd83/sexVih/ZF0Vm88XeCYEwJQUc0oSD4C3mfq1mfTwpBPRvy0IWV3IaxEmB9EVpeAtIG2Zp0wUgiDFz3F7SBDsYpE89gfLWEXC6UpDNOMBF6G/3+YQ8bwoEgbBEgFcJ9GsbadAmzL6pgoawLFHmDfmUOWZ8cvanS3dhQD+ErZmU+RhQQMW7AMt3mqkcyzmc2zTaBMONtZljxxFVfT5DQYhipzngrhqzE3LVVVxfwfaz7ZoP/0tE+rstn0iWBHcsNifbEPCMudjJOYCJ25NzhLOOwfKGwdyC26UNnqaBRpvipoX2GMwtuFfz2yU7QZ/dnMhqxWBO5q7vA6ZX43YpDGu+8xLvE3EwfC7DybE+Afdo3KtFzEQYd9M6czT6QgYxX1qtI9iem43nHhFZ35DWrPYaIpbMxnSqXXv+B3sISmgfMuYOAAAAAElFTkSuQmCC);
      }
      .questions {
        font-family: PingFangSC-Medium;
        margin-left: 16px;
        font-size: 20px;
        line-height: 33px;
        color: #333;
        letter-spacing: 0;
      }
    }
    .content {
      margin-top: 20px;
      line-height: 30px;
      display: flex;
      .answers-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADpElEQVRYCcVXTWgTQRT+ZtNUbRITa021SlH6B/5BqRYUFfyr9OBRRFAQLYiCBz0J4t2LoofSS714Ek9eROmhVEVBPYg/VZRaaZX+JzZNappkN+N702wqqdnsSlIfbHZ2dub73vvezNuMQI6NRuUWCXQIoA0StdT25gxx9Eg4MQgME04PtbvX+UT/nwDUN29SyvKxGG7S03kpoZn9xbwLgTThda314rIQIsnYyoEM+SMiPlBMwnxY5EgvOdHOTqhIOfKlImenmCujNgTnnPrelUp2CxU4HdvLeMHRYitJzvORc78KWKBDo0XQZjWwlO+YW+OtVkoSS2zi5hRY7nNt+idckWkYqyrhCk8htbEuixma0fH8cwyD4wmMR1Ko9rtRt3YZdjd5sdpXlh2Xr8HcYmSGsmFha65fI+IQpMcDbTaGqYtX8DYdxLOPUfQPxyFo9ZSVCQQDboSiOoy0BG0vbK1dgV2NXjStX26BTnMt39LL5KZ6VFDkgsgNnx96ZRVud49BuICa1eU43OxHS70H5eREypB4M/gLfR9m8H7ol7punLbOcEEHIsdOQSSTKB8aROjcJaXEQSJtrq9AQ818dBMRHS8pFTsaPGjNXJyWj9/jheJDwRQwgqGn4Y7HoHtXgrdNrr36Mou7vZM4vq8KezdbLqncqfb2/4Vb33Di9gTeDswuAlAdtIoMkl9S/tnuPQuj731UtQv92CpAaQNIpahw5Vmu9C0Bj+HXfL34FMU7WgN2zJYDHJ2KMK8DQJqiNxXQKWWS5tgxew5Q8GmWOIOYSEpcvTOM+30h1cMbmR00TfL4hUez+6/3gruAZzHgnwokdImBH3MIeOanmyl4/HoaLz/RdqXxK9y2YitcB0y3VbnK1CzeCKyIGaWpwGgoiYnpFNZQRWzfGTCnWt5tKWAiZFVlyUkFdsI0g8I+eaga+5tXqqJk9he629MpB4Vp05xnuthUzqntIjSuiE7snxzwVWhwE9HnoTjic7TiiVE5tCCIbR8cpcBEpW8NDrYE8PBFGGevf4Xf61IpefCUCtCbCH2gBDQK7ciOAPZs85nT/nq35UBbqx9h+tJtCC7Lgpw5GlQqPCHCkckENNJ/PJzAZITJBVwugVCjnh2fryFGZ2SUlHNWwPOhOewnIWMaHxoczivecOLWKPqe4iE6Q2Lu//63XMuc1bqc+V6U0V3MrarGfz+a8Rlt/qyGzswBsigh5oIwNl2d5rmQ3y+qm0t9PP8N5ESUFHS19TYAAAAASUVORK5CYII=);
      }
      .answers {
        width: 1100px;
        padding-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
      }
      .less {
        width: 1075px;
      }
      .zoom {
        align-self: flex-end;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1072e0;
        text-align: right;
        cursor: pointer;
      }
    }
    .bottom {
      height: 30px;
      line-height: 30px;
      margin-top: 15px;
      display: flex;
      margin-left: 48px;
      align-items: center;
      .item-tag {
        min-width: 64px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        padding: 0 8px;
        background: #e8f0ff;
        border-radius: 12px;
        font-size: 12px;
        color: #1072e0;
      }
      .time {
        margin-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666;
        letter-spacing: 0;
      }
    }
  }
}
</style>
